import { formatCurrency, formatDate } from "../utils/format-utils";
import Language from "./Language";
import store from "../store";

export default class ServiceRate {
  serviceRateId?: number | null;
  programId?: number | null;
  programName?: string | null;
  serviceId?: number | null;
  serviceCode?: string | null;
  serviceName?: string | null;
  isBilingual?: boolean | null;
  isGroup?: boolean | null;
  groupSize?: number | null;
  districts?: number[] | null;
  sessionLocationCategory?: string | null;
  sessionLocationId?: number | null;
  effectiveDate?: Date | null;
  lastEffectiveDate?: Date | null;
  amount?: number | null;
  rateUnitTypeId?: number | null;
  rateUnitType?: string | null;
  languages?: Language[] | null;
  rateSummary?: string | null;

  public constructor(params: ServiceRate = {} as ServiceRate) {
    let {
      serviceRateId = 0,
      programId = null,
      programName = null,
      serviceId = null,
      serviceCode = "",
      serviceName = "",
      isBilingual = false,
      isGroup = false,
      groupSize = null,
      districts = [],
      sessionLocationCategory = "",
      sessionLocationId = null,
      effectiveDate = null,
      lastEffectiveDate = null,
      amount = 0,
      rateUnitTypeId = null,
      rateUnitType = "",
      languages = [],
      rateSummary = "",
    } = params;
    this.serviceRateId = serviceRateId;
    this.programId = programId;
    this.programName = programName;
    this.serviceId = serviceId;
    this.serviceCode = serviceCode;
    this.serviceName = serviceName;
    this.isBilingual = isBilingual;
    this.isGroup = isGroup;
    this.groupSize = groupSize;
    this.districts = districts;
    this.sessionLocationCategory = sessionLocationCategory;
    this.sessionLocationId = sessionLocationId;
    this.effectiveDate = effectiveDate;
    this.lastEffectiveDate = lastEffectiveDate;
    this.amount = amount;
    this.rateUnitTypeId = rateUnitTypeId;
    this.rateUnitType = rateUnitType;
    this.languages = languages;
    this.rateSummary = rateSummary;
  }

  get serviceText() {
    return this.serviceCode + " - " + this.serviceName;
  }

  get bilingual() {
    return this.isBilingual ? "Yes" : "No";
  }

  get formattedGroupSize() {
    return this.isGroup ? this.groupSize : "N/A";
  }

  get formattedDistricts() {
    return this.districts ? this.districts.join(",") : "N/A";
  }

  get formattedLocation() {
    if (this.sessionLocationCategory === "Non_applicable") {
      return "N/A";
    } else if (this.sessionLocationCategory === "Specific location") {
      return store.getters["optionsModule/location"](this.sessionLocationId);
    }
    return this.sessionLocationCategory;
  }

  get formattedLanguages() {
    return this.languages ? this.languages.map((i) => i.name).join(",") : "N/A";
  }

  get formattedEffectiveDate() {
    return formatDate(this.effectiveDate);
  }

  get formattedLastEffectiveDate() {
    return this.lastEffectiveDate ? formatDate(this.lastEffectiveDate) : "N/A";
  }

  get formattedAmount() {
    return formatCurrency(this.amount);
  }
}
